/**
 * Labstep
 *
 * @module components/Comment/List/Pin
 * @desc Comment List for pinned comments
 */

import cx from 'classnames';
import { HorizontalDivider } from 'labstep-web/core/Divider';
import { ReadOnMountHOC } from 'labstep-web/hoc/ReadOnMount';
import {
  getPinCommentListParametersExperimentWorkflow,
  getPinCommentListParametersParentThread,
} from 'labstep-web/state/reducers/helpers/entities/comment';
import type React from 'react';
import { CommentList } from '..';
import type { ICommentListPinProps } from './types';

export const CommentListPin: React.FC<ICommentListPinProps> = ({
  threadId,
  experimentWorkflowId,
  header,
}) => {
  let parameters = {};

  if (experimentWorkflowId) {
    parameters = getPinCommentListParametersExperimentWorkflow(
      experimentWorkflowId,
    );
  } else if (threadId) {
    parameters = getPinCommentListParametersParentThread(threadId);
  }

  return (
    <ReadOnMountHOC
      key={JSON.stringify(parameters)}
      entityName="comment"
      type="cursor"
      params={parameters}
      pagination={{
        infinite: false,
        loader: false,
      }}
      children={({ entities }) => (
        <div
          className={cx('pinCommentList')}
          data-testid="comment-list-pin"
        >
          <CommentList header={header} comments={entities} showPin />
          {entities.length > 0 && <HorizontalDivider />}
        </div>
      )}
    />
  );
};
